import { create } from '@thoughtspot/logger';
import _ from 'lodash';
import React, { useContext } from 'react';
import { createContainer } from 'react-tracked';
export function getLocalContext(contextName, reducer, defaultValues, getDispatcherFunctions) {
    const logger = create(contextName);
    const StateContext = React.createContext({});
    const DispatchContext = React.createContext(undefined);
    const ContextProvider = ({ children, value = {}, }) => {
        const [state, dispatch] = React.useReducer(reducer, {
            ...defaultValues,
            ...value,
        });
        const disptachers = React.useMemo(() => getDispatcherFunctions(dispatch), [dispatch]);
        return (React.createElement(StateContext.Provider, { value: state },
            React.createElement(DispatchContext.Provider, { value: disptachers }, children)));
    };
    const { Provider: TrackedProvider, useTrackedState, useUpdate: useDispatch, } = createContainer(({ initialState }) => React.useReducer(reducer, initialState));
    const TrackedContextProvider = ({ children, value = {}, }) => {
        const initialState = {
            ...defaultValues,
            ...value,
        };
        return (React.createElement(TrackedProvider, { initialState: initialState }, children));
    };
    const getTrackedState = () => {
        try {
            return useTrackedState() || defaultValues;
        }
        catch (e) {
            if (/Please use <Provider>/.test(e === null || e === void 0 ? void 0 : e.message)) {
                return {};
            }
            throw e;
        }
    };
    const getTrackedMethods = () => {
        const dispatch = useDispatch();
        return React.useMemo(() => dispatch
            ? getDispatcherFunctions(dispatch)
            : {}, [dispatch]);
    };
    const getState = () => {
        const context = useContext(StateContext);
        if (_.isUndefined(context)) {
            logger.error('This state must be used within the context:', contextName);
        }
        return context;
    };
    const getStateSetterMethods = () => {
        const context = useContext(DispatchContext);
        if (_.isUndefined(context)) {
            logger.error('This Dispatcher must be used within the context:', contextName);
        }
        return context;
    };
    ContextProvider.displayName = `${contextName}ContextProvider`;
    return {
        ContextProvider,
        getState,
        getStateSetterMethods,
        TrackedContextProvider,
        getTrackedState,
        getTrackedMethods,
    };
}
//# sourceMappingURL=local-context.js.map